module.exports = "<div class=\"float--right\" ng-init=\"$ctrl.openModal()\">\r\n    <!--Don't remove this -->\r\n    <!--This is needed for the modal popup-->\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/directives/startupModal/startup.html
 ** module id = 442
 ** module chunks = 0
 **/